import { useSyncExternalStore } from 'react';
import { useTranslation } from 'react-i18next';

import { esitoLoginFinestra, iscrivitiEsitoLoginFinestra } from '@/lib/loginFinestra';

/**
 * Il messaggio della finestra di login di Telegram Web (`lib/loginFinestra.ts`), sotto il suo «Accedi»: popup bloccato, finestra
 * chiusa prima di finire, tempo scaduto, ritorno rifiutato. Niente schermata nuova e niente bottone nuovo: si riprova con lo
 * stesso «Accedi», cioe' con un gesto nuovo. Chi lo monta lo mette dietro il confronto LETTERALE del flag, cosi' a flag spento non c'e'.
 */
export function EsitoLoginFinestra() {
  const { t } = useTranslation('general');
  const esito = useSyncExternalStore(iscrivitiEsitoLoginFinestra, esitoLoginFinestra, esitoLoginFinestra);
  if (!esito) return null;
  return (
    <p role="alert" className="text-center text-sm text-danger" data-esito-login-finestra={esito}>
      {t(`auth.finestra.${esito}`)}
    </p>
  );
}
